import "normalize.css";
import "./scss/global.scss";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick-theme.scss";
import "slick-carousel/slick/slick.scss";
import "leaflet/dist/leaflet.css";
import "leaflet/dist/images/marker-icon.png";
import "lightbox2";
import "lightbox2/dist/js/lightbox";
import "lightbox2/dist/css/lightbox.css";
import "swiper/swiper-bundle.css";
import gsap from "gsap";
import AOS from "aos";

(() => {
	const mobilePopupMenu = document.querySelector(".mobile-nav-popup");

	function openMenu() {
		const openingTimeline = gsap.timeline();
		openingTimeline.set(mobilePopupMenu, { display: "block" });
		openingTimeline.from(mobilePopupMenu, { opacity: "0" });

		document.querySelector("body").style.overflowY = "hidden";
	}

	function closeMenu() {
		const closingTimeline = gsap.timeline();
		closingTimeline.to(mobilePopupMenu, { opacity: "0" });
		closingTimeline.set(mobilePopupMenu, { display: "none" });

		document.querySelector("body").style.overflowY = "scroll";
	}

	const openMenuButton = document.querySelector(".js-open-menu");

	openMenuButton.addEventListener("click", (e) => {
		e.preventDefault();
		openMenu();
	});

	const closeMenuButton = document.querySelector(".js-close-menu");

	closeMenuButton.addEventListener("click", (e) => {
		e.preventDefault();
		closeMenu();
	});
})();

// (() => {
// 	window.addEventListener("scroll", () => {
// 		if (window.pageYOffset > 100) {
// 			gsap.to(".page .nav-fixed", {
// 				duration: 0.3,
// 				backgroundColor: "rgba(255, 255, 255, 1)",
// 			});
// 		} else {
// 			gsap.to(".page .nav-fixed", {
// 				duration: 0.3,
// 				backgroundColor: "rgba(255, 255, 255, 0)",
// 			});
// 		}
// 	});
// })();

(() => {
	AOS.init();
})();
